export const settingsIt: Record<string, string> = {
  'settings.fittingRooms.title': 'Camerini di Prova',
  'settings.fittingRooms.addPlaceholder': 'Inserisci nome camerino...',
  'settings.fittingRooms.description': 'Gestisci i camerini per organizzare gli appuntamenti per posizione',
  'settings.fittingRooms.syncGoogleCalendar': 'Sincronizza Google Calendar',
  'settings.fittingRooms.syncing': 'Sincronizzazione...',
  'settings.fittingRooms.roomName': 'Nome Camerino',
  'settings.fittingRooms.addRoom': 'Aggiungi Camerino',
  'settings.fittingRooms.currentRooms': 'Camerini Attuali',
  'settings.fittingRooms.default': 'Predefinito',
  'settings.fittingRooms.appointmentsCreated': '{count} appuntamenti • Creato {date}',
  'settings.fittingRooms.calendar': 'Calendario',
  'settings.fittingRooms.copied': 'Copiato',
  'settings.fittingRooms.calendarCopied': 'ID calendario copiato negli appunti',
  'settings.fittingRooms.deleteTitle': 'Elimina Camerino',
  'settings.fittingRooms.deleteConfirm': 'Sei sicuro di voler eliminare "{name}"? Questa azione non può essere annullata.',
  'settings.fittingRooms.cannotDeleteWithAppointments': 'Impossibile eliminare il camerino con {count} appuntamenti',
  'settings.fittingRooms.noRooms': 'Nessun camerino creato ancora',
  'settings.fittingRooms.noRoomsDescription': 'Aggiungi il tuo primo camerino per iniziare',
  'settings.fittingRooms.noteLabel': 'Nota',
  'settings.fittingRooms.noteDescription': 'Il Camerino Predefinito non può essere eliminato. Gli altri camerini possono essere eliminati solo se non hanno appuntamenti.',
  'settings.fittingRooms.error.load': 'Impossibile caricare i camerini',
  'settings.fittingRooms.error.enterName': 'Inserisci un nome camerino',
  'settings.fittingRooms.error.create': 'Impossibile creare il camerino',
  'settings.fittingRooms.error.update': 'Impossibile aggiornare il camerino',
  'settings.fittingRooms.error.delete': 'Impossibile eliminare il camerino',
  'settings.fittingRooms.error.sync': 'Impossibile sincronizzare il calendario',
  'settings.fittingRooms.success.created': 'Camerino creato con successo',
  'settings.fittingRooms.success.updated': 'Camerino aggiornato con successo',
  'settings.fittingRooms.success.deleted': 'Camerino eliminato con successo',
  'settings.fittingRooms.success.sync': '{message}. Controlla Google Calendar per verificare la sincronizzazione.',
  'settings.integrations.googleCalendar.title': 'Google Calendar',
  'settings.integrations.googleCalendar.status.connected': 'Connesso',
  'settings.integrations.googleCalendar.status.disconnected': 'Disconnesso',
  'settings.integrations.googleCalendar.resync': 'Risincronizza Tutto',
  'settings.integrations.error.enterWhatsAppToken': 'Inserisci un token API WhatsApp',
  'settings.integrations.common.disconnect': 'Disconnetti',
  'settings.integrations.google.workspace': 'Google Workspace',
  'settings.integrations.google.description': 'Connetti account Google per sincronizzare i calendari',
  'settings.integrations.google.connectedSuccess': 'Google Workspace connesso con successo',
  'settings.integrations.google.connectError': 'Impossibile connettere Google Workspace',
  'settings.integrations.google.disconnectedSuccess': 'Google Workspace disconnesso con successo',
  'settings.integrations.google.disconnectError': 'Impossibile disconnettere Google Workspace',
  'settings.integrations.google.syncSuccess': 'Sincronizzazione calendario completata con successo',
  'settings.integrations.google.syncError': 'Impossibile sincronizzare i calendari',
  'settings.integrations.google.errorPrefix': 'Errore integrazione Google:',
  'settings.integrations.google.fixNow': 'Correggi ora',
  'settings.integrations.google.lastSynced': 'Ultima sincronizzazione',
  'settings.integrations.google.never': 'Mai',
  'settings.integrations.google.synced': 'Sincronizzati',
  'settings.integrations.google.pending': 'In attesa',
  'settings.integrations.google.failed': 'Falliti',
  'settings.integrations.google.total': 'Totale',
  'settings.integrations.google.reauthorize': 'Riautorizza',
  'settings.integrations.google.disconnectTitle': 'Disconnettere Google Workspace?',
  'settings.integrations.google.disconnectDescription': 'Questo rimuoverà l\'accesso al tuo account Google e interromperà la sincronizzazione di appuntamenti e contatti.',
  'settings.integrations.google.connecting': 'Connessione...',
  'settings.integrations.google.connectAction': 'Connetti Google Workspace',
  'settings.integrations.whatsapp.business': 'WhatsApp Business',
  'settings.integrations.whatsapp.description': 'Invia promemoria appuntamenti e aggiornamenti tramite WhatsApp',
  'settings.integrations.whatsapp.apiActive': 'Connessione API attiva',
  'settings.integrations.whatsapp.connectedSuccess': 'Integrazione WhatsApp connessa con successo',
  'settings.integrations.whatsapp.connectError': 'Impossibile connettere integrazione WhatsApp',
  'settings.integrations.whatsapp.disconnectedSuccess': 'Integrazione WhatsApp disconnessa con successo',
  'settings.integrations.whatsapp.disconnectError': 'Impossibile disconnettere integrazione WhatsApp',
  'settings.integrations.whatsapp.disconnectTitle': 'Disconnettere WhatsApp?',
  'settings.integrations.whatsapp.disconnectDescription': 'Questo rimuoverà il token API WhatsApp e interromperà l\'invio messaggi tramite WhatsApp.',
  'settings.integrations.whatsapp.apiToken': 'Token API',
  'settings.integrations.whatsapp.apiTokenPlaceholder': 'Inserisci il token API WhatsApp Business',
  'settings.integrations.whatsapp.connecting': 'Connessione...',
  'settings.integrations.whatsapp.saveConnect': 'Salva e Connetti',
  'settings.integrations.googleCalendar.description': 'Sincronizza appuntamenti con calendari Google specifici per camerino',
  'settings.integrations.googleCalendar.active': 'Sincronizzazione calendario attiva',
  'settings.integrations.googleCalendar.connectFirst': 'Connetti prima Google Workspace per abilitare la sincronizzazione calendario',
  'settings.integrations.stripe.title': 'Stripe Connect',
  'settings.integrations.stripe.description': 'Abilita pagamenti cliente tramite Stripe',
  'settings.integrations.stripe.connectedTitle': 'Stripe connesso',
  'settings.integrations.stripe.connectedDescription': 'Il tuo account Stripe Express è pronto.',
  'settings.integrations.stripe.connectError': 'Impossibile connettere Stripe',
  'settings.integrations.stripe.disconnectedSuccess': 'Stripe disconnesso con successo',
  'settings.integrations.stripe.disconnectError': 'Impossibile disconnettere Stripe',
  'settings.integrations.stripe.account': 'Account',
  'settings.integrations.stripe.continueOnboarding': 'Continua onboarding',
  'settings.integrations.stripe.disconnectTitle': 'Disconnettere Stripe?',
  'settings.integrations.stripe.disconnectDescription': 'Questo disabiliterà l\'elaborazione pagamenti per la tua organizzazione. I clienti non potranno pagare fatture o saldi.',
  'settings.integrations.stripe.businessCountry': 'Paese azienda',
  'settings.integrations.stripe.selectCountry': 'Seleziona paese',
  'settings.integrations.stripe.connecting': 'Connessione...',
  'settings.integrations.stripe.connectAction': 'Connetti Stripe',

  // Supplier Management
  'supplier.list.title': 'Fornitori',
  'supplier.list.subtitle': 'Gestisci i fornitori e i relativi prezzi',
  'supplier.list.tableTitle': 'Tutti i fornitori ({count})',
  'supplier.list.loading': 'Caricamento fornitori...',
  'supplier.list.error.title': 'Impossibile caricare i fornitori',
  'supplier.list.error.description': 'Riprova.',
  'supplier.list.empty.title': 'Nessun fornitore trovato',
  'supplier.list.empty.searchDescription': 'Prova a modificare i termini di ricerca.',
  'supplier.list.empty.defaultDescription': 'Inizia aggiungendo il tuo primo fornitore.',
  'supplier.list.empty.addFirst': 'Aggiungi primo fornitore',
  'supplier.list.filters.clear': 'Cancella',
  'supplier.list.deleteConfirm': 'Sei sicuro di voler eliminare il fornitore \"{name}\"?',
  'supplier.form.leadTime': 'Tempo di Consegna (giorni)',
  'supplier.priceList.title': 'Listino Prezzi',
  'supplier.performance.label': 'Performance',
  'supplier.form.name': 'Nome Fornitore',
  'supplier.form.contactEmail': 'Email di Contatto',
  'supplier.form.contactPhone': 'Telefono di Contatto',
  'supplier.form.website': 'Sito Web',
  'supplier.form.address': 'Indirizzo',
  'supplier.form.taxId': 'Partita IVA',
  'supplier.form.notes': 'Note',
  'supplier.actions.add': 'Aggiungi Fornitore',
  'supplier.actions.edit': 'Modifica Fornitore',
  'supplier.actions.delete': 'Elimina Fornitore',
  'supplier.actions.view': 'Vedi Dettagli',
  'supplier.table.name': 'Nome',
  'supplier.table.contact': 'Contatto',
  'supplier.table.leadTime': 'Tempo di Consegna',
  'supplier.table.leadTimeValue': '{count} giorni',
  'supplier.table.products': '# Prodotti',
  'supplier.table.performance': 'Performance',
  'supplier.table.actions': 'Azioni',
  'supplier.pagination.previous': 'Precedente',
  'supplier.pagination.next': 'Successivo',
  'supplier.pagination.page': 'Pagina {page} di {total}',
  'supplier.pricing.addPrice': 'Aggiungi Prezzo',
  'supplier.pricing.saveChanges': 'Salva Modifiche',
  'supplier.pricing.product': 'Prodotto',
  'supplier.pricing.costPrice': 'Prezzo di Costo',
  'supplier.pricing.currency': 'Valuta',
  'supplier.pricing.selectProduct': 'Seleziona un prodotto',
  'supplier.products.title': 'Prodotti Forniti',
  'supplier.performance.onTimeDelivery': 'Consegna Puntuale',
  'supplier.performance.qualityScore': 'Punteggio Qualità',
  'supplier.performance.responseTime': 'Tempo di Risposta',
  'supplier.detail.tabs.profile': 'Profilo',
  'supplier.detail.tabs.pricing': 'Listino Prezzi',
  'supplier.detail.tabs.products': 'Prodotti',
  'supplier.detail.tabs.performance': 'Performance',
  'supplier.messages.created': 'Fornitore creato con successo',
  'supplier.messages.updated': 'Fornitore aggiornato con successo',
  'supplier.messages.deleted': 'Fornitore eliminato con successo',
  'supplier.messages.error': 'Impossibile caricare i fornitori',
  'supplier.search.placeholder': 'Cerca fornitori...',
  'supplier.messages.productRemoved': 'Prodotto rimosso dal fornitore',
  'supplier.messages.productRemoveError': 'Impossibile rimuovere il prodotto',
  'supplier.messages.loadProductsError': 'Impossibile caricare i prodotti del fornitore',

  // Notifications
  'notifications.tab.unread': 'Non Letti',
  'notifications.tab.all': 'Tutti',
  'notifications.empty.unread': 'Tutto in ordine!',
  'notifications.empty.unread.description': 'Nessuna notifica non letta al momento.',
  'notifications.empty.all': 'Nessuna notifica ancora',
  'notifications.empty.all.description': 'Vedrai aggiornamenti e avvisi importanti qui.',
  'notifications.markAsRead': 'Segna come letto',
  'notifications.viewAll': 'Visualizza Tutte le Notifiche',
  'notifications.title': 'Notifiche',
  'notifications.subtitle': 'Rimani aggiornato con avvisi e promemoria importanti',

  // Campi Personalizzati Impostazioni
  'settings.customFields.title': 'Campi Personalizzati',
  'settings.customFields.description': 'Crea campi personalizzati mappabili alle sottomissioni dei moduli',
  'settings.customFields.addField': 'Aggiungi Campo Personalizzato',
  'settings.customFields.noFieldsYet': 'Nessun campo personalizzato ancora',
  'settings.customFields.required': 'Obbligatorio',
  'settings.customFields.key': 'Chiave',
  'settings.customFields.options': 'Opzioni',
  'settings.customFields.deleteConfirm': 'Sei sicuro di voler eliminare "{name}"? Questa azione non può essere annullata.',
  'settings.customFields.createTitle': 'Crea Campo Personalizzato',
  'settings.customFields.editTitle': 'Modifica Campo Personalizzato',
  'settings.customFields.fieldName': 'Nome Campo',
  'settings.customFields.fieldNamePlaceholder': 'es., Descrizione Matrimonio dei Sogni',
  'settings.customFields.fieldKey': 'Chiave Campo',
  'settings.customFields.fieldKeyPlaceholder': 'es., descrizione_matrimonio_sogni',
  'settings.customFields.fieldKeyDescription': 'Usato internamente per memorizzare i dati. Deve essere univoco.',
  'settings.customFields.fieldKeyCannotChange': 'La chiave del campo non può essere modificata dopo la creazione.',
  'settings.customFields.fieldType': 'Tipo Campo',
  'settings.customFields.usedFor': 'Utilizzato Per',
  'settings.customFields.type.text': 'Testo',
  'settings.customFields.type.longText': 'Testo Lungo',
  'settings.customFields.type.number': 'Numero',
  'settings.customFields.type.date': 'Data',
  'settings.customFields.type.yesNo': 'Sì/No',
  'settings.customFields.type.dropdown': 'Menu a Tendina',
  'settings.customFields.entity.leadsOnly': 'Solo Contatti',
  'settings.customFields.entity.customersOnly': 'Solo Clienti',
  'settings.customFields.entity.both': 'Entrambi',
  'settings.customFields.addOption': 'Aggiungi opzione',
  'settings.customFields.requiredField': 'Campo Obbligatorio',
  'settings.customFields.requiredFieldDescription': 'Segna questo campo come obbligatorio per le sottomissioni dei moduli',
  'settings.customFields.creating': 'Creazione...',
  'settings.customFields.createField': 'Crea Campo',
  'settings.customFields.updating': 'Aggiornamento...',
  'settings.customFields.updateField': 'Aggiorna Campo',

  // Traduzioni Fasi
  'settings.stages.previewAs': 'Anteprima etichette come:',
  'settings.stages.editTranslations': 'Modifica Traduzioni Fase',
  'settings.stages.stage': 'Fase:',
  'settings.stages.label': 'Etichetta {locale}',
  'settings.stages.enterLabel': 'Inserisci etichetta {locale}...',
  'settings.stages.characters': '{count}/100 caratteri',
  'settings.stages.preview': 'Anteprima',
  'settings.stages.noLabel': 'Nessuna etichetta',
  'settings.stages.saveTranslation': 'Salva Traduzione {locale}',
  'settings.stages.saveAllChanges': 'Salva Tutte le Modifiche',
  'settings.stages.validationError': 'Errore di Validazione',
  'settings.stages.labelLength': "L'etichetta deve essere tra 3 e 100 caratteri",
  'settings.stages.loadError': 'Impossibile caricare le traduzioni',

  // Modal Sincronizzazione Google Calendar
  'settings.sync.manageCalendarSync': 'Gestisci Sincronizzazione Calendario',
  'settings.sync.title': 'Gestione Sincronizzazione Google Calendar',

  // Impostazioni Notifiche
  'settings.notifications.title': 'Impostazioni Notifiche',
  'settings.notifications.description': 'Configura come ricevi le notifiche da Sposa Suite',
  'settings.notifications.push.title': 'Notifiche Push',
  'settings.notifications.push.description': "Ricevi notifiche in tempo reale anche quando l'app è chiusa",
  'settings.notifications.push.browser': 'Notifiche Push del Browser',
  'settings.notifications.push.browserDesc': 'Ricevi notifiche su aggiornamenti importanti istantaneamente',
  'settings.notifications.push.notSupported': 'Non Supportato',
  'settings.notifications.push.error': 'Errore',
  'settings.notifications.push.active': 'Attivo',
  'settings.notifications.push.permissionGranted': 'Permesso Accordato',
  'settings.notifications.push.denied': 'Negato',
  'settings.notifications.push.notSet': 'Non Impostato',
  'settings.notifications.push.errorTitle': 'Errore Notifiche Push',
  'settings.notifications.push.retrySubscription': 'Riprova Iscrizione',
  'settings.notifications.push.testNotification': 'Test Notifica',
  'settings.notifications.push.notSupportedMsg': 'Le notifiche push non sono supportate in questo browser. Usa un browser moderno come Chrome, Firefox o Safari.',
  'settings.notifications.email.title': 'Notifiche Email',
  'settings.notifications.email.description': 'Ricevi notifiche via email',
  'settings.notifications.email.label': 'Notifiche Email',
  'settings.notifications.email.desc': 'Ricevi aggiornamenti importanti via email',
  'settings.notifications.types.title': 'Tipi di Notifica',
  'settings.notifications.types.description': 'Scegli quali tipi di notifiche vuoi ricevere',
  'settings.notifications.types.leadReminders': 'Promemoria Contatti',
  'settings.notifications.types.leadRemindersDesc': 'Promemoria di follow-up per i contatti',
  'settings.notifications.types.taskNotifications': 'Notifiche Attività',
  'settings.notifications.types.taskNotificationsDesc': 'Notifiche per assegnazioni e aggiornamenti attività',
  'settings.notifications.types.appointmentReminders': 'Promemoria Appuntamenti',
  'settings.notifications.types.appointmentRemindersDesc': 'Promemoria per appuntamenti imminenti',
  'settings.notifications.settingsUpdated': 'Impostazioni Aggiornate',
  'settings.notifications.settingsUpdatedDesc': 'Le tue preferenze di notifica sono state salvate',
  'settings.notifications.saveError': 'Impossibile salvare le preferenze di notifica',

  // Regole Lead
  'settings.leadRules.title': 'Regole Contatti',
  'settings.leadRules.description': 'Gestisci le regole automatiche di follow-up per i contatti',
  'settings.leadRules.addRule': 'Aggiungi Regola',
  'settings.leadRules.createTitle': 'Crea Regola Contatto',
  'settings.leadRules.ruleName': 'Nome Regola',
  'settings.leadRules.ruleNamePlaceholder': 'es., Follow-up nuove richieste',
  'settings.leadRules.triggerEvent': 'Evento Trigger',
  'settings.leadRules.selectTrigger': 'Seleziona evento trigger',
  'settings.leadRules.triggerNewLead': 'Nuovo Contatto',
  'settings.leadRules.triggerStageChange': 'Cambio Fase',
  'settings.leadRules.triggerNoActivity': 'Nessuna Attività',
  'settings.leadRules.triggerStage': 'Fase Trigger',
  'settings.leadRules.selectStage': 'Seleziona fase',
  'settings.leadRules.delayMinutes': 'Ritardo (minuti)',
  'settings.leadRules.delayRange': '1-2880 minuti (48 ore max)',
  'settings.leadRules.action': 'Azione',
  'settings.leadRules.selectAction': 'Seleziona azione',
  'settings.leadRules.actionEmail': 'Invia Email (In arrivo)',
  'settings.leadRules.actionPush': 'Notifica Push',
  'settings.leadRules.creating': 'Creazione...',
  'settings.leadRules.createRule': 'Crea Regola',
  'settings.leadRules.noRules': 'Nessuna regola contatto configurata',
  'settings.leadRules.noRulesDesc': 'Crea la tua prima regola per automatizzare i follow-up dei contatti',
  'settings.leadRules.table.name': 'Nome Regola',
  'settings.leadRules.table.trigger': 'Trigger',
  'settings.leadRules.table.delay': 'Ritardo',
  'settings.leadRules.table.action': 'Azione',
  'settings.leadRules.table.status': 'Stato',
  'settings.leadRules.deleteTitle': 'Elimina Regola Contatto',
  'settings.leadRules.deleteConfirm': 'Sei sicuro di voler eliminare "{name}"? Questa azione non può essere annullata e fermerà tutti i promemoria futuri da questa regola.',
  'settings.leadRules.deleteRule': 'Elimina Regola',
  'settings.leadRules.enabled': 'Attiva',
  'settings.leadRules.disabled': 'Disattiva',
  'settings.leadRules.stageLabel': 'Fase: {name}',
  'settings.leadRules.success.created': 'Regola contatto creata con successo',
  'settings.leadRules.success.deleted': 'Regola eliminata con successo',
  'settings.leadRules.success.toggled': 'Regola {status} con successo',
  'settings.leadRules.error.load': 'Impossibile caricare le regole contatto',
  'settings.leadRules.error.create': 'Impossibile creare la regola',
  'settings.leadRules.error.delete': 'Impossibile eliminare la regola',
  'settings.leadRules.error.update': 'Impossibile aggiornare la regola',
  'settings.leadRules.error.requiredFields': 'Compila tutti i campi obbligatori',

  // Autenticazione Portale
  'settings.portalAuth.title': 'Autenticazione Portale',
  'settings.portalAuth.description': 'Configura come i clienti accedono al tuo portale. Entrambi i metodi forniscono autenticazione sicura senza password.',
  'settings.portalAuth.otpEnabled': 'Abilita Codici di Accesso (OTP)',
  'settings.portalAuth.otpEnabledDesc': 'Permetti ai clienti di accedere con codici a 6 cifre inviati alla loro email',
  'settings.portalAuth.otpInfo': 'I codici di accesso sono particolarmente utili per gli utenti PWA che potrebbero avere problemi con i link magici che si aprono in browser esterni.',
  'settings.portalAuth.smsEnabled': 'Abilita Codici SMS',
  'settings.portalAuth.smsEnabledDesc': 'Permetti ai clienti di ricevere codici via SMS (richiede numeri di telefono registrati)',
  'settings.portalAuth.smsInfo': 'Configura il tuo provider SMS qui sotto per abilitare la consegna SMS dei codici di autenticazione.',
  'settings.portalAuth.smsProviderConfig': 'Configurazione Provider SMS',
  'settings.portalAuth.smsProvider': 'Provider SMS',
  'settings.portalAuth.selectSmsProvider': 'Seleziona provider SMS',
  'settings.portalAuth.senderId': 'ID Mittente',
  'settings.portalAuth.senderIdPlaceholder': 'Nome della Tua Organizzazione',
  'settings.portalAuth.senderIdDesc': 'Il nome o numero che appare come mittente dei messaggi SMS.',
  'settings.portalAuth.twilioConfig': 'Configurazione Twilio',
  'settings.portalAuth.accountSid': 'Account SID',
  'settings.portalAuth.authToken': 'Token di Autenticazione',
  'settings.portalAuth.apiKey': 'Chiave API',
  'settings.portalAuth.apiSecret': 'Segreto API',
  'settings.portalAuth.emailTemplateSettings': 'Impostazioni Template Email',
  'settings.portalAuth.emailSubject': 'Oggetto Email',
  'settings.portalAuth.emailTemplate': 'Template Email',
  'settings.portalAuth.availableVars': 'Variabili disponibili: {{orgName}}, {{code}}, {{customerName}}',
  'settings.portalAuth.customizeEmail': 'Personalizza il contenuto email. Variabili: {{orgName}}, {{code}}, {{customerName}}',
  'settings.portalAuth.saveChanges': 'Salva Modifiche',
  'settings.portalAuth.saving': 'Salvataggio...',
  'settings.portalAuth.resetToDefaults': 'Ripristina Predefiniti',
  'settings.portalAuth.securityFeatures': 'Funzionalità di Sicurezza:',
  'settings.portalAuth.securityExpiry': 'I codici scadono in 10 minuti',
  'settings.portalAuth.securityRateLimit': 'Limite: 5 codici per ora, 20 al giorno',
  'settings.portalAuth.securityLockout': "Blocco account dopo 5 tentativi falliti (15 min)",
  'settings.portalAuth.securitySession': 'Le sessioni durano 180 giorni con auto-refresh',
  'settings.portalAuth.securityAudit': 'Tutti gli eventi sono registrati per audit',
  'settings.portalAuth.settingsSaved': 'Impostazioni Salvate',
  'settings.portalAuth.settingsSavedDesc': 'Le impostazioni di autenticazione del portale sono state aggiornate con successo.',
  'settings.portalAuth.loadError': 'Impossibile caricare le impostazioni di autenticazione',
  'settings.portalAuth.saveError': 'Impossibile salvare le impostazioni di autenticazione',

  // Branding
  'settings.branding.title': 'Branding Portale',
  'settings.branding.description': "Personalizza l'aspetto del portale clienti per le spose. Le modifiche influenzano l'esperienza dell'app installabile.",
  'settings.branding.preview': 'Anteprima',
  'settings.branding.portalShortName': 'Nome Breve Portale:',
  'settings.branding.browserTabIcon': 'Icona scheda browser e app',
  'settings.branding.defaultLanguage': 'Lingua Predefinita:',
  'settings.branding.shortNameLabel': 'Nome Breve Portale (Opzionale)',
  'settings.branding.shortNameDesc': "Usato come nome dell'app sui dispositivi mobili. Lascia vuoto per usare il nome dell'organizzazione.",
  'settings.branding.brandColor': 'Colore del Brand',
  'settings.branding.brandColorDesc': 'Colore principale usato in tutto il portale clienti e tema PWA.',
  'settings.branding.defaultPortalLanguage': 'Lingua Predefinita Portale',
  'settings.branding.defaultPortalLanguageDesc': 'La lingua predefinita che i clienti vedono quando visitano il portale per la prima volta. Possono cambiarla usando il selettore lingua.',
  'settings.branding.portalLogo': 'Logo Portale',
  'settings.branding.currentLogo': 'Logo attuale',
  'settings.branding.logoUsedIn': "Usato nell'intestazione del portale e nelle schermate di benvenuto",
  'settings.branding.changeLogo': 'Cambia Logo',
  'settings.branding.chooseLogo': 'Scegli Logo',
  'settings.branding.uploadLogoDesc': 'Carica il logo della tua organizzazione per il portale clienti',
  'settings.branding.logoSizeHint': 'PNG, JPG fino a 5MB. Consigliato: 512×512px',
  'settings.branding.appIcon': 'Icona App / Favicon',
  'settings.branding.currentFavicon': 'Favicon attuale',
  'settings.branding.faviconUsedIn': "Usato nelle schede del browser e quando installato come PWA",
  'settings.branding.changeIcon': 'Cambia Icona',
  'settings.branding.chooseIcon': 'Scegli Icona',
  'settings.branding.uploadFaviconDesc': "Carica un'icona/favicon separata (opzionale)",
  'settings.branding.faviconSizeHint': 'PNG, ICO fino a 2MB. Consigliato: 32×32px o 48×48px',
  'settings.branding.faviconFallback': "Se nessuna icona viene caricata, il logo verrà usato come fallback per le schede del browser e l'installazione PWA.",
  'settings.branding.customerPortal': 'Portale Clienti',
  'settings.branding.pwaReady': 'PWA Pronto',
  'settings.branding.pwaReadyDesc': 'I clienti possono installare il tuo portale come app sui loro telefoni',
  'settings.branding.saving': 'Salvataggio...',
  'settings.branding.saveChanges': 'Salva Modifiche',
  'settings.branding.settingsSaved': 'Impostazioni salvate',
  'settings.branding.settingsSavedDesc': 'Le impostazioni di branding sono state aggiornate con successo.',
  'settings.branding.loadError': 'Impossibile caricare le impostazioni di branding',
  'settings.branding.saveError': 'Impossibile salvare le impostazioni di branding',
  'settings.branding.invalidFile': 'File non valido',
  'settings.branding.selectImage': "Seleziona un file immagine",
  'settings.branding.fileTooLarge': 'File troppo grande',
  'settings.branding.logoMaxSize': "Seleziona un'immagine inferiore a 5MB",
  'settings.branding.faviconMaxSize': "Seleziona un'icona inferiore a 2MB",
  'settings.branding.uploadFailed': 'Caricamento fallito',
  'settings.branding.uploadFailedDesc': 'Impossibile caricare il logo. Riprova.',
  'settings.branding.faviconUploadFailed': 'Impossibile caricare la favicon. Riprova.',

  // Traduzioni Documenti
  'settings.translations.title': 'Traduzioni Documenti',
  'settings.translations.description': 'Gestisci le traduzioni per documenti PDF in più lingue',
  'settings.translations.bulkEdit': 'Modifica in Blocco',
  'settings.translations.newTranslation': 'Nuova Traduzione',
  'settings.translations.saveChanges': 'Salva Modifiche ({count})',
  'settings.translations.documentType': 'Tipo Documento',
  'settings.translations.language': 'Lingua',
  'settings.translations.searchPlaceholder': 'Cerca traduzioni...',
  'settings.translations.table.key': 'Chiave Traduzione',
  'settings.translations.table.value': 'Valore Traduzione',
  'settings.translations.table.updated': 'Ultimo Aggiornamento',
  'settings.translations.table.actions': 'Azioni',
  'settings.translations.loading': 'Caricamento traduzioni...',
  'settings.translations.noTranslations': 'Nessuna traduzione trovata per {docType} in {locale}',
  'settings.translations.editTitle': 'Modifica Traduzione',
  'settings.translations.createTitle': 'Crea Traduzione',
  'settings.translations.editorDescription': 'Crea o modifica traduzioni per documenti PDF.',
  'settings.translations.translationKey': 'Chiave Traduzione',
  'settings.translations.keyPlaceholder': 'es., PAYMENT_REQUEST_TITLE',
  'settings.translations.translationValue': 'Valore Traduzione',
  'settings.translations.valuePlaceholder': 'Inserisci il testo tradotto...',
  'settings.translations.saveTranslation': 'Salva Traduzione',
  'settings.translations.docType.paymentRequest': 'Richiesta di Pagamento',
  'settings.translations.docType.invoice': 'Fattura',
  'settings.translations.docType.receipt': 'Ricevuta',
  'settings.translations.success.created': 'Traduzione creata con successo',
  'settings.translations.success.updated': 'Traduzione aggiornata con successo',
  'settings.translations.success.bulkUpdated': '{count} traduzioni aggiornate con successo',
  'settings.translations.error.load': 'Impossibile caricare le traduzioni',
  'settings.translations.error.save': 'Impossibile salvare la traduzione',
  'settings.translations.error.bulkSave': 'Impossibile aggiornare le traduzioni in blocco',

  // Editor Contenuti Avanzato
  'settings.contentEditor.editArticle': 'Modifica Articolo',
  'settings.contentEditor.createArticle': 'Crea Articolo',
  'settings.contentEditor.updateArticle': 'Aggiorna Articolo',
  'settings.contentEditor.description': 'Crea e visualizza contenuti in più formati',
  'settings.contentEditor.title': 'Titolo',
  'settings.contentEditor.titlePlaceholder': 'es., Come prepararsi per la prova',
  'settings.contentEditor.urlSlug': 'URL Slug',
  'settings.contentEditor.slugPlaceholder': 'come-prepararsi-per-la-prova',
  'settings.contentEditor.contentType': 'Tipo Contenuto',
  'settings.contentEditor.selectType': 'Seleziona tipo',
  'settings.contentEditor.category': 'Categoria',
  'settings.contentEditor.selectCategory': 'Seleziona categoria',
  'settings.contentEditor.language': 'Lingua',
  'settings.contentEditor.selectLanguage': 'Seleziona lingua',
  'settings.contentEditor.excerpt': 'Estratto',
  'settings.contentEditor.excerptPlaceholder': 'Breve descrizione',
  'settings.contentEditor.tags': 'Tag (separati da virgola, opzionale)',
  'settings.contentEditor.tagsPlaceholder': 'prova, preparazione, biancheria intima',
  'settings.contentEditor.edit': 'Modifica',
  'settings.contentEditor.previewTab': 'Anteprima',
  'settings.contentEditor.content': 'Contenuto',
  'settings.contentEditor.contentPlaceholder': 'Inserisci il tuo contenuto {type} qui...',
  'settings.contentEditor.htmlHint': 'Inserisci HTML valido. Il contenuto verrà sanificato per sicurezza.',
  'settings.contentEditor.markdownHint': 'Usa la sintassi markdown. Supporta intestazioni, elenchi, link e altro.',
  'settings.contentEditor.previewEmpty': "Inizia a digitare nella scheda modifica per vedere l'anteprima del contenuto qui.",

  // Gestore Sincronizzazione Appuntamenti
  'settings.syncManager.title': 'Sincronizzazione Appuntamenti',
  'settings.syncManager.description': 'Monitora e gestisci la sincronizzazione con Google Calendar',
  'settings.syncManager.healthy': 'Operativo',
  'settings.syncManager.syncing': 'In Sincronizzazione',
  'settings.syncManager.needsAttention': 'Richiede Attenzione',
  'settings.syncManager.successfullySynced': 'Sincronizzati con Successo',
  'settings.syncManager.pendingSync': 'In Attesa di Sincronizzazione',
  'settings.syncManager.failedSyncs': 'Sincronizzazioni Fallite',
  'settings.syncManager.totalProcessed': 'Totale Elaborati',
  'settings.syncManager.last24h': 'Ultime 24h',
  'settings.syncManager.queue': 'Coda',
  'settings.syncManager.errors': 'Errori',
  'settings.syncManager.allTime': 'Sempre',
  'settings.syncManager.syncPerformance': 'Prestazioni Sincronizzazione',
  'settings.syncManager.excellent': 'Eccellente',
  'settings.syncManager.good': 'Buono',
  'settings.syncManager.fair': 'Discreto',
  'settings.syncManager.poor': 'Scarso',
  'settings.syncManager.successRate': 'Tasso di Successo',
  'settings.syncManager.failureRate': 'Tasso di Errore',
  'settings.syncManager.realTimeMetrics': 'Metriche in Tempo Reale',
  'settings.syncManager.activeSyncs': 'Sincronizzazioni Attive',
  'settings.syncManager.avgTime': 'Tempo Medio',
  'settings.syncManager.queueSize': 'Dimensione Coda',
  'settings.syncManager.systemStatus': 'Stato Sistema',
  'settings.syncManager.resyncing': 'Risincronizzazione...',
  'settings.syncManager.resyncFailed': 'Risincronizza Falliti ({count})',
  'settings.syncManager.processing': 'Elaborazione...',
  'settings.syncManager.processRetryQueue': 'Elabora Coda Ritentativi',
  'settings.syncManager.queueManagement': 'Gestione Coda',
  'settings.syncManager.queueDescription': 'Monitoraggio avanzato e controlli coda sincronizzazione',
  'settings.syncManager.pending': 'in attesa',
  'settings.syncManager.syncScheduleConfig': 'Configurazione Pianificazione Sincronizzazione',
  'settings.syncManager.syncScheduleDesc': 'Configura intervalli di sincronizzazione automatica e notifiche',
  'settings.syncManager.autoSync': 'Sincronizzazione Automatica',
  'settings.syncManager.autoSyncDesc': 'Elabora automaticamente la coda di sincronizzazione a intervalli regolari',
  'settings.syncManager.syncInterval': 'Intervallo Sincronizzazione (minuti)',
  'settings.syncManager.every5min': 'Ogni 5 minuti',
  'settings.syncManager.every15min': 'Ogni 15 minuti',
  'settings.syncManager.every30min': 'Ogni 30 minuti',
  'settings.syncManager.everyHour': 'Ogni ora',
  'settings.syncManager.every3hours': 'Ogni 3 ore',
  'settings.syncManager.syncNotifications': 'Notifiche Sincronizzazione',
  'settings.syncManager.syncNotificationsDesc': 'Ricevi notifiche su errori di sincronizzazione ed eventi importanti',
  'settings.syncManager.exportSyncData': 'Esporta Dati Sincronizzazione',
  'settings.syncManager.exportDesc': 'Esporta log e statistiche di sincronizzazione per analisi',
  'settings.syncManager.exportCsv': 'Esporta come CSV',
  'settings.syncManager.exportJson': 'Esporta come JSON',
  'settings.syncManager.exportIncludes': 'Include: tipo operazione, stato, timestamp, messaggi di errore e conteggio ritentativi',
  'settings.syncManager.overview': 'Panoramica',
  'settings.syncManager.queueItems': 'Elementi in Coda',
  'settings.syncManager.analytics': 'Analisi',
  'settings.syncManager.health': 'Salute',
  'settings.syncManager.queueProcessed': 'Coda elaborata',
  'settings.syncManager.queueProcessedDesc': 'La coda di sincronizzazione è stata elaborata con successo.',
  'settings.syncManager.queueProcessFailed': 'Elaborazione coda fallita',
  'settings.syncManager.queueProcessFailedDesc': 'Impossibile elaborare la coda di sincronizzazione. Riprova.',
  'settings.syncManager.retryQueued': 'Elementi falliti in coda per ritentativo',
  'settings.syncManager.retryQueuedDesc': 'Gli elementi di sincronizzazione falliti sono stati messi in coda per il ritentativo.',
  'settings.syncManager.retryFailed': 'Ritentativo fallito',
  'settings.syncManager.retryFailedDesc': 'Impossibile mettere in coda gli elementi per il ritentativo. Riprova.',
  'settings.syncManager.itemsCleared': 'Elementi falliti eliminati',
  'settings.syncManager.itemsClearedDesc': 'Gli elementi di sincronizzazione falliti sono stati eliminati dalla coda.',
  'settings.syncManager.clearFailed': 'Eliminazione fallita',
  'settings.syncManager.clearFailedDesc': 'Impossibile eliminare gli elementi. Riprova.',
  'settings.syncManager.exportCompleted': 'Esportazione completata',
  'settings.syncManager.exportCompletedDesc': 'Log di sincronizzazione esportati come file {format}.',
  'settings.syncManager.exportFailed': 'Esportazione fallita',
  'settings.syncManager.exportFailedDesc': 'Impossibile esportare i log di sincronizzazione. Riprova.',
  'settings.syncManager.scheduleUpdated': 'Pianificazione sincronizzazione aggiornata',
  'settings.syncManager.highFailureRate': 'Alto tasso di errore',
  'settings.syncManager.elevatedFailures': 'Errori elevati',
  'settings.syncManager.syncingInProgress': 'Sincronizzazione in corso',
  'settings.syncManager.allOperational': 'Tutti i sistemi operativi',

  // Fatturazione
  'settings.billing.paymentSettings': 'Impostazioni Pagamento',
  'settings.billing.paymentSettingsDesc': 'Configura le opzioni di pagamento per il portale clienti',
  'settings.billing.minPaymentLabel': 'Importo Minimo Pagamento (€)',
  'settings.billing.minPaymentDesc': "L'importo minimo che i clienti possono pagare attraverso il portale clienti",
  'settings.billing.minPaymentUpdated': 'Importo minimo pagamento aggiornato con successo',
  'settings.billing.minPaymentError': "Impossibile aggiornare l'importo minimo",
  'settings.billing.invalidAmount': 'Importo Non Valido',
  'settings.billing.minAmountError': "L'importo minimo deve essere almeno €0,01",
  'settings.billing.currentPlan': 'Piano Attuale',
  'settings.billing.seatsUsed': 'Postazioni Utilizzate',
  'settings.billing.additionalSeats': 'Le postazioni aggiuntive saranno fatturate alla prossima fattura.',
  'settings.billing.nextBilling': 'Prossima fatturazione:',
  'settings.billing.managementTitle': 'Gestione Fatturazione',
  'settings.billing.managementDesc': 'Aggiorna metodi di pagamento, scarica fatture e gestisci il tuo abbonamento',
  'settings.billing.manageSubscription': 'Gestisci Abbonamento',
  'settings.billing.openingPortal': 'Apertura Portale...',
  'settings.billing.portalError': 'Impossibile aprire il portale di fatturazione',
  'settings.billing.paymentFailed': "L'ultimo pagamento non è andato a buon fine. Aggiorna il metodo di pagamento per evitare interruzioni del servizio.",
  'settings.billing.retryPayment': 'Riprova Pagamento',
  'settings.billing.seatOverage': 'Stai usando {used} postazioni ma ne hai solo {allowed} nel tuo piano.',
  'settings.billing.upgradePlan': 'Aggiorna Piano',
  'settings.billing.planFeatures': 'Funzionalità del Piano',
  'settings.billing.planFeaturesDesc': 'Tutto incluso nel tuo piano {plan}',
  'settings.billing.feature.paymentMethods': 'Aggiorna metodi di pagamento',
  'settings.billing.feature.invoices': 'Scarica fatture',
  'settings.billing.feature.changePlan': 'Cambia o cancella piano',
  'settings.billing.feature.billingAddress': 'Aggiorna indirizzo di fatturazione',
  'settings.billing.feature.teamManagement': 'Gestione Team',
  'settings.billing.feature.teamMembers': 'Fino a {count} membri del team',
  'settings.billing.feature.scheduling': 'Pianificazione Avanzata',
  'settings.billing.feature.schedulingDesc': 'Sincronizzazione calendario e promemoria automatici',
  'settings.billing.feature.support': 'Supporto Prioritario',
  'settings.billing.feature.supportDesc': 'Supporto email e chat 24/7',

  // Orari di Lavoro
  'settings.businessHours.title': 'Orari di Lavoro',
  'settings.businessHours.holidaysTitle': 'Festività e Chiusure',
  'settings.businessHours.date': 'Data *',
  'settings.businessHours.name': 'Nome *',
  'settings.businessHours.namePlaceholder': 'es., Natale',
  'settings.businessHours.addHoliday': 'Aggiungi Festività',
  'settings.businessHours.description': 'Descrizione',
  'settings.businessHours.descriptionPlaceholder': 'Descrizione opzionale',
  'settings.businessHours.upcomingHolidays': 'Prossime Festività',
  'settings.businessHours.noHolidays': 'Nessuna festività configurata',
  'settings.businessHours.remove': 'Rimuovi',
  'settings.businessHours.to': 'a',
  'settings.businessHours.closed': 'Chiuso',
  'settings.businessHours.break': 'Pausa: {start} - {end}',
  'settings.businessHours.addBreak': 'Aggiungi Pausa',
  'settings.businessHours.day.sunday': 'Domenica',
  'settings.businessHours.day.monday': 'Lunedì',
  'settings.businessHours.day.tuesday': 'Martedì',
  'settings.businessHours.day.wednesday': 'Mercoledì',
  'settings.businessHours.day.thursday': 'Giovedì',
  'settings.businessHours.day.friday': 'Venerdì',
  'settings.businessHours.day.saturday': 'Sabato',
  'settings.businessHours.updated': 'Orari di lavoro aggiornati',
  'settings.businessHours.updateError': 'Impossibile aggiornare gli orari di lavoro',
  'settings.businessHours.fetchError': 'Impossibile caricare gli orari di lavoro',
  'settings.businessHours.holidayAdded': 'Festività aggiunta con successo',
  'settings.businessHours.holidayAddError': 'Impossibile aggiungere la festività',
  'settings.businessHours.holidayDeleted': 'Festività eliminata con successo',
  'settings.businessHours.holidayDeleteError': 'Impossibile eliminare la festività',
  'settings.businessHours.breakAdded': 'Pausa aggiunta con successo',
  'settings.businessHours.breakAddError': 'Impossibile aggiungere la pausa',
  'settings.businessHours.breakDeleted': 'Pausa eliminata con successo',
  'settings.businessHours.breakDeleteError': 'Impossibile eliminare la pausa',
  'settings.businessHours.breakTimesError': 'Compila gli orari di inizio e fine',
  'settings.businessHours.breakClosedDayError': 'Impossibile aggiungere pausa in giorno chiuso',
  'settings.businessHours.breakOutsideHoursError': 'La pausa deve essere entro gli orari di lavoro ({open} - {close})',
  'settings.businessHours.requiredFieldsError': 'Compila tutti i campi obbligatori',

  // Pannello Template
  'settings.templates.title': 'Template Messaggi',
  'settings.templates.description': 'Gestisci template email, SMS, Magic Link, Inviti Utente e Conferma Pagamento con contenuto dinamico',
  'settings.templates.language': 'Lingua:',
  'settings.templates.locale.enUS': 'Inglese (US)',
  'settings.templates.locale.esES': 'Spagnolo (Spagna)',
  'settings.templates.locale.frFR': 'Francese (Francia)',
  'settings.templates.locale.deDE': 'Tedesco (Germania)',
  'settings.templates.locale.itIT': 'Italiano (Italia)',
  'settings.templates.newTemplate': 'Nuovo Template',
  'settings.templates.table.name': 'Nome',
  'settings.templates.table.channel': 'Canale',
  'settings.templates.table.language': 'Lingua',
  'settings.templates.table.subject': 'Oggetto/Anteprima',
  'settings.templates.table.lastEdited': 'Ultima Modifica',
  'settings.templates.table.actions': 'Azioni',
  'settings.templates.loading': 'Caricamento template...',
  'settings.templates.noTemplates': 'Nessun template trovato per {locale}',
  'settings.templates.system': 'Sistema',
  'settings.templates.systemCannotEdit': 'I template di sistema non possono essere modificati direttamente',
  'settings.templates.editTemplate': 'Modifica template',
  'settings.templates.testWith': 'Testa con...',
  'settings.templates.channelMagicLink': 'MAGIC LINK',
  'settings.templates.channelUserInvitation': 'INVITO UTENTE',
  'settings.templates.channelPasswordReset': 'RESET PASSWORD',
  'settings.templates.channelPayment': 'PAGAMENTO',
  'settings.templates.editTitle': 'Modifica Template',
  'settings.templates.createTitle': 'Crea Template',
  'settings.templates.editorDescription': 'Crea template dinamici usando variabili Handlebars per messaggi personalizzati.',
  'settings.templates.templateName': 'Nome Template',
  'settings.templates.templateNamePlaceholder': 'es., Promemoria Appuntamento',
  'settings.templates.channel': 'Canale',
  'settings.templates.channelEmail': 'Email',
  'settings.templates.channelSms': 'SMS',
  'settings.templates.channelPaymentConfirmation': 'Conferma Pagamento',
  'settings.templates.subjectLine': 'Riga Oggetto',
  'settings.templates.subjectPlaceholder': 'es., Il tuo appuntamento con {{organization.name}}',
  'settings.templates.messageContent': 'Contenuto Messaggio',
  'settings.templates.code': 'Codice',
  'settings.templates.preview': 'Anteprima',
  'settings.templates.contentPlaceholder': 'Inserisci il contenuto del messaggio con variabili come {{customer.first_name}}',
  'settings.templates.availableVariables': 'Variabili Disponibili',
  'settings.templates.noContentPreview': 'Nessun contenuto da visualizzare',
  'settings.templates.cancel': 'Annulla',
  'settings.templates.updateTemplate': 'Aggiorna Template',
  'settings.templates.createTemplate': 'Crea Template',
  'settings.templates.success.updated': 'Template aggiornato con successo',
  'settings.templates.success.created': 'Template creato con successo',
  'settings.templates.error.load': 'Impossibile caricare i template',
  'settings.templates.error.save': 'Impossibile {action} il template',
  'settings.templates.error.selectCustomer': 'Seleziona un cliente per il test',
  'settings.templates.success.testSent': 'Test {type} inviato con successo',
  'settings.templates.error.testSend': 'Impossibile inviare il messaggio di test',

  // Pannello Template Attività
  'settings.taskTemplates.title': 'Template Attività',
  'settings.taskTemplates.description': 'Configura la generazione automatica di template attività per contatti e clienti',
  'settings.taskTemplates.leadTasks': 'Attività Contatti',
  'settings.taskTemplates.customerTasks': 'Attività Clienti',
  'settings.taskTemplates.populateExamples': 'Popola Esempi',
  'settings.taskTemplates.addTemplate': 'Aggiungi Template',
  'settings.taskTemplates.searchPlaceholder': 'Cerca template...',
  'settings.taskTemplates.noTemplates': 'Nessun template attività trovato',
  'settings.taskTemplates.changeSearch': 'Prova a modificare la ricerca',
  'settings.taskTemplates.disabled': 'Disattivato',
  'settings.taskTemplates.titleTemplate': 'Template Titolo',
  'settings.taskTemplates.dueOffset': 'Scadenza',
  'settings.taskTemplates.descriptionLabel': 'Descrizione',
  'settings.taskTemplates.createNew': 'Crea Nuovo',
  'settings.taskTemplates.editLabel': 'Modifica',
  'settings.taskTemplates.dialogTitle': '{mode} Template Attività',
  'settings.taskTemplates.dialogDescription': 'Configura quando e come le attività devono essere generate automaticamente',
  'settings.taskTemplates.templateName': 'Nome Template',
  'settings.taskTemplates.templateNamePlaceholder': "Es., 'Follow-up Nuovo Contatto'",
  'settings.taskTemplates.entityType': 'Tipo Entità',
  'settings.taskTemplates.selectEntity': 'Seleziona tipo entità',
  'settings.taskTemplates.entityLead': 'Contatto',
  'settings.taskTemplates.entityCustomer': 'Cliente',
  'settings.taskTemplates.triggerEvent': 'Evento Trigger',
  'settings.taskTemplates.selectTrigger': 'Seleziona evento trigger',
  'settings.taskTemplates.leadCreated': 'Contatto Creato',
  'settings.taskTemplates.stagePrefix': 'Fase: {name}',
  'settings.taskTemplates.milestoneDepositPaid': 'Milestone: Acconto Pagato',
  'settings.taskTemplates.milestoneOrderPlaced': 'Milestone: Ordine Effettuato',
  'settings.taskTemplates.milestoneFirstFitting': 'Milestone: Prima Prova Programmata',
  'settings.taskTemplates.milestoneDelivery': 'Milestone: Consegna Prevista',
  'settings.taskTemplates.milestonePostSale': 'Milestone: Follow-up Post-Vendita',
  'settings.taskTemplates.dueOffsetLabel': 'Scadenza',
  'settings.taskTemplates.selectTimeOffset': 'Seleziona intervallo',
  'settings.taskTemplates.offset.5m': '5 minuti',
  'settings.taskTemplates.offset.10m': '10 minuti',
  'settings.taskTemplates.offset.30m': '30 minuti',
  'settings.taskTemplates.offset.1h': '1 ora',
  'settings.taskTemplates.offset.4h': '4 ore',
  'settings.taskTemplates.offset.8h': '8 ore',
  'settings.taskTemplates.offset.1d': '1 giorno',
  'settings.taskTemplates.offset.2d': '2 giorni',
  'settings.taskTemplates.offset.3d': '3 giorni',
  'settings.taskTemplates.offset.1w': '1 settimana',
  'settings.taskTemplates.offset.30d': '30 giorni',
  'settings.taskTemplates.taskTitleTemplate': 'Template Titolo Attività',
  'settings.taskTemplates.taskTitlePlaceholder': "Es., 'Follow-up con {{name}}'",
  'settings.taskTemplates.descTemplate': 'Template Descrizione (Opzionale)',
  'settings.taskTemplates.descTemplatePlaceholder': "Es., 'Verifica se {{name}} ha domande sulla richiesta'",
  'settings.taskTemplates.pushNotifications': 'Notifiche Push',
  'settings.taskTemplates.emailNotifications': 'Notifiche Email',
  'settings.taskTemplates.templateEnabled': 'Template Attivo',
  'settings.taskTemplates.cancel': 'Annulla',
  'settings.taskTemplates.create': 'Crea',
  'settings.taskTemplates.update': 'Aggiorna',
  'settings.taskTemplates.deleteTitle': 'Elimina Template',
  'settings.taskTemplates.deleteConfirm': 'Sei sicuro di voler eliminare il template "{name}"? Questa azione non può essere annullata.',
  'settings.taskTemplates.deleteTemplate': 'Elimina Template',
  'settings.taskTemplates.validationError': 'Errore di Validazione',
  'settings.taskTemplates.validationMessage': 'Compila tutti i campi obbligatori',
  'settings.taskTemplates.success.created': 'Template attività creato con successo',
  'settings.taskTemplates.success.updated': 'Template attività aggiornato con successo',
  'settings.taskTemplates.success.deleted': 'Template attività eliminato con successo',
  'settings.taskTemplates.success.toggled': 'Template {status} con successo',
  'settings.taskTemplates.success.populated': '{count} template attività aggiunti con successo',
  'settings.taskTemplates.error.load': 'Impossibile caricare i template attività',
  'settings.taskTemplates.error.save': 'Impossibile salvare il template attività',
  'settings.taskTemplates.error.delete': 'Impossibile eliminare il template attività',
  'settings.taskTemplates.error.toggle': 'Impossibile aggiornare lo stato del template',
  'settings.taskTemplates.error.populate': 'Impossibile popolare i template attività',

  // Pannello Contenuti Portale
  'settings.portalContent.title': 'Contenuti Portale',
  'settings.portalContent.description': 'Gestisci articoli FAQ e contenuti di aiuto per il portale clienti',
  'settings.portalContent.newArticle': 'Nuovo Articolo',
  'settings.portalContent.allArticles': 'Tutti gli Articoli ({count})',
  'settings.portalContent.published': 'Pubblicati ({count})',
  'settings.portalContent.drafts': 'Bozze ({count})',
  'settings.portalContent.publishedArticles': 'Articoli Pubblicati',
  'settings.portalContent.publishedDescription': 'Trascina e rilascia per riordinare come gli articoli appaiono nel portale clienti',
  'settings.portalContent.publishedBadge': 'Pubblicato',
  'settings.portalContent.table.title': 'Titolo',
  'settings.portalContent.table.category': 'Categoria',
  'settings.portalContent.table.language': 'Lingua',
  'settings.portalContent.table.status': 'Stato',
  'settings.portalContent.table.updatedAt': 'Aggiornato Il',
  'settings.portalContent.table.actions': 'Azioni',
  'settings.portalContent.loading': 'Caricamento articoli...',
  'settings.portalContent.noArticles': 'Nessun articolo trovato',
  'settings.portalContent.uncategorized': 'Senza categoria',
  'settings.portalContent.edit': 'Modifica',
  'settings.portalContent.unpublish': 'Rimuovi Pubblicazione',
  'settings.portalContent.publish': 'Pubblica',
  'settings.portalContent.delete': 'Elimina',
  'settings.portalContent.success.updated': 'Articolo aggiornato con successo',
  'settings.portalContent.success.created': 'Articolo creato con successo',
  'settings.portalContent.success.published': 'Articolo pubblicato con successo',
  'settings.portalContent.success.unpublished': 'Pubblicazione articolo rimossa con successo',
  'settings.portalContent.success.deleted': 'Articolo eliminato con successo',
  'settings.portalContent.error.load': 'Impossibile caricare gli articoli',
  'settings.portalContent.error.save': 'Impossibile {action} articolo',
  'settings.portalContent.error.status': "Impossibile aggiornare lo stato dell'articolo",
  'settings.portalContent.error.delete': "Impossibile eliminare l'articolo",
  'settings.portalContent.error.reorder': 'Impossibile riordinare gli articoli',

  // Gestore Sincronizzazione (chiavi aggiuntive)
  'settings.syncManager.completed': 'Completati',
  'settings.syncManager.failed': 'Falliti',
  'settings.syncManager.processQueue': 'Elabora Coda ({count})',
  'settings.syncManager.failedItems': 'Elementi Falliti ({count})',
  'settings.syncManager.retryAllFailed': 'Riprova Tutti Falliti',
  'settings.syncManager.clearAllFailed': 'Elimina Tutti Falliti',
  'settings.syncManager.avgProcessingTime': 'Tempo Medio Elaborazione',
  'settings.syncManager.searchQueueItems': 'Cerca elementi in coda...',
  'settings.syncManager.status': 'Stato',
  'settings.syncManager.allStatus': 'Tutti gli Stati',
  'settings.syncManager.operation': 'Operazione',
  'settings.syncManager.allOperations': 'Tutte le Operazioni',
  'settings.syncManager.create': 'Crea',
  'settings.syncManager.updateOp': 'Aggiorna',
  'settings.syncManager.deleteOp': 'Elimina',
  'settings.syncManager.resync': 'Risincronizza',
  'settings.syncManager.itemsSelected': '{count} elemento/i selezionato/i',
  'settings.syncManager.clear': 'Cancella',
  'settings.syncManager.retrySelected': 'Riprova Selezionati',
  'settings.syncManager.removeSelected': 'Rimuovi Selezionati',
  'settings.syncManager.noQueueItems': 'Nessun elemento in coda trovato',
  'settings.syncManager.adjustFilters': 'Prova a modificare la ricerca o i filtri',
  'settings.syncManager.showingItems': 'Mostrando {count} elementi',
  'settings.syncManager.selectAllVisible': 'Seleziona Tutti Visibili',
  'settings.syncManager.retries': '{count} ritentativi',
  'settings.syncManager.viewDetails': 'Vedi Dettagli',
  'settings.syncManager.processingTimeTrends': 'Tendenze Tempo Elaborazione',
  'settings.syncManager.chartComingSoon': 'Grafico in arrivo',
  'settings.syncManager.errorRateAnalysis': 'Analisi Tasso Errore',
  'settings.syncManager.queueHealthIndicators': 'Indicatori Salute Coda',
  'settings.syncManager.errorRate': 'Tasso Errore',
  'settings.syncManager.avgProcessing': 'Elaborazione Media',
  'settings.syncManager.queueLoad': 'Carico Coda',
  'settings.syncManager.light': 'Leggero',
  'settings.syncManager.moderate': 'Moderato',
  'settings.syncManager.heavy': 'Pesante',
  'settings.syncManager.systemHealthDashboard': 'Dashboard Salute Sistema',
  'settings.syncManager.alertsEnabled': 'Avvisi attivi',
  'settings.syncManager.alertsDisabled': 'Avvisi disattivi',
  'settings.syncManager.connectionQuality': 'Qualità Connessione',
  'settings.syncManager.stable': 'stabile',
  'settings.syncManager.unstable': 'instabile',
  'settings.syncManager.poor2': 'scarsa',
  'settings.syncManager.idle': 'inattivo',
  'settings.syncManager.allOperational2': 'Tutti i sistemi operativi',
  'settings.syncManager.someIssues': 'Alcuni problemi rilevati',
  'settings.syncManager.multipleFailures': 'Multipli errori rilevati',
  'settings.syncManager.noRecentActivity': 'Nessuna attività recente',
  'settings.syncManager.itemsInQueue': '{count} elementi in coda',
  'settings.syncManager.processingSpeed': 'Velocità Elaborazione',
  'settings.syncManager.fast': 'Veloce',
  'settings.syncManager.slow': 'Lento',
  'settings.syncManager.avgSeconds': '~{count}s media',
  'settings.syncManager.healthAlerts': 'Avvisi Salute e Raccomandazioni',
  'settings.syncManager.highFailureDetected': 'Alto Tasso di Errore Rilevato',
  'settings.syncManager.highFailureDesc': '{count} elementi falliti richiedono attenzione. Verifica la connessione a Google Calendar.',
  'settings.syncManager.queueBacklog': 'Avviso Arretrato Coda',
  'settings.syncManager.queueBacklogDesc': 'Coda grande rilevata ({count} elementi). Considera di elaborare la coda o ridurre la frequenza di sincronizzazione.',
  'settings.syncManager.slowProcessing': 'Prestazioni Elaborazione Lente',
  'settings.syncManager.slowProcessingDesc': 'Il tempo medio di elaborazione è {count}s. Verifica la connettività di rete.',
  'settings.syncManager.allHealthy': 'Tutti i Sistemi Operativi',
  'settings.syncManager.allHealthyDesc': 'Il sistema di sincronizzazione funziona in modo ottimale senza problemi rilevati.',
  'settings.syncManager.quickActions': 'Azioni Rapide',
  'settings.syncManager.configureSchedule': 'Configura Pianificazione',
  'settings.syncManager.exportReports': 'Esporta Report',
  'settings.syncManager.clearFailedTitle': 'Eliminare Elementi Falliti?',
  'settings.syncManager.clearFailedConfirmDesc': 'Questo rimuoverà {count} elementi falliti dalla coda. Questa azione non può essere annullata.',
  'settings.syncManager.clearFailedItems': 'Elimina Elementi Falliti',
  'settings.syncManager.legacySync': 'Sincronizzazione Legacy (v1)',
  'settings.syncManager.legacySyncDesc': 'Sincronizza appuntamenti dal sistema legacy',
  'settings.syncManager.syncingV1': 'Sincronizzazione appuntamenti v1...',
  'settings.syncManager.resyncAllV1': 'Risincronizza Tutti gli Appuntamenti v1',
  'settings.syncManager.saveChanges': 'Salva Modifiche',

  // Pannello Organizzazione
  'settings.org.title': "Dettagli Organizzazione",
  'settings.org.description': "Configura le informazioni di base e il branding della tua organizzazione",
  'settings.org.loadError': "Impossibile caricare le impostazioni dell'organizzazione",
  'settings.org.saveSuccess': "Impostazioni dell'organizzazione aggiornate con successo",
  'settings.org.saveError': "Impossibile salvare le impostazioni dell'organizzazione",
  'settings.org.orgName': "Nome Organizzazione",
  'settings.org.orgNamePlaceholder': "Inserisci il nome dell'organizzazione",
  'settings.org.streetAddress': 'Indirizzo',
  'settings.org.streetAddressPlaceholder': 'Via Piave, 15',
  'settings.org.city': 'Città',
  'settings.org.cityPlaceholder': 'Varese',
  'settings.org.province': 'Provincia',
  'settings.org.provincePlaceholder': 'VA',
  'settings.org.phone': 'Telefono',
  'settings.org.phonePlaceholder': '+39 0332 123456',
  'settings.org.fax': 'Fax (Opzionale)',
  'settings.org.faxPlaceholder': '+39 0332 123457',
  'settings.org.vatId': 'Partita IVA',
  'settings.org.vatIdPlaceholder': 'IT12345678901',
  'settings.org.taxId': 'Codice Fiscale',
  'settings.org.taxIdPlaceholder': '12345678901',
  'settings.org.defaultLocale': 'Locale Predefinito',
  'settings.org.selectLocale': 'Seleziona locale',
  'settings.org.timezone': 'Fuso Orario',
  'settings.org.timezoneRegion.utc': 'UTC',
  'settings.org.timezoneRegion.africa': 'Africa',
  'settings.org.timezoneRegion.americas': 'Americhe',
  'settings.org.timezoneRegion.asia': 'Asia',
  'settings.org.timezoneRegion.europe': 'Europa',
  'settings.org.timezoneRegion.oceania': 'Oceania',
  'settings.org.selectTimezone': 'Seleziona fuso orario...',
  'settings.org.searchTimezone': 'Cerca fuso orario...',
  'settings.org.noTimezoneFound': 'Nessun fuso orario trovato.',
  'settings.org.logo': "Logo dell'Organizzazione",
  'settings.org.logoAlt': "Logo dell'organizzazione",
  'settings.org.upload': 'Carica',
  'settings.org.remove': 'Rimuovi',
  'settings.org.logoHint': 'PNG o JPG, max 1MB, 512×512px consigliato',
  'settings.org.logoSizeError': 'Il file del logo deve essere inferiore a 1MB',
  'settings.org.logoFormatError': 'Carica un file PNG o JPG',
  'settings.org.logoDimensionsError': 'Le dimensioni del logo devono essere 512×512 pixel o inferiori',
  'settings.org.logoUploadSuccess': 'Logo caricato con successo',
  'settings.org.logoUploadError': 'Impossibile caricare il logo',
  'settings.org.invalidImageError': 'File immagine non valido',
  'settings.org.saveChanges': 'Salva Modifiche',

  // Pannello Fasi
  'settings.stagesPanel.workflowTitle': 'Fasi del Workflow',
  'settings.stagesPanel.workflowDescription': 'Configura le fasi per i workflow di gestione contatti e alterazioni',
  'settings.stagesPanel.leadStages': 'Fasi Contatti',
  'settings.stagesPanel.alterationStages': 'Fasi Alterazioni',
  'settings.stagesPanel.addStage': 'Aggiungi Fase',
  'settings.stagesPanel.lead': 'Contatto',
  'settings.stagesPanel.alteration': 'Alterazione',
  'settings.stagesPanel.addNewStage': 'Aggiungi Nuova Fase {type}',
  'settings.stagesPanel.createDescription': 'Crea una nuova fase per il workflow {type}',
  'settings.stagesPanel.stageName': 'Nome Fase',
  'settings.stagesPanel.stageNamePlaceholder': 'Inserisci nome fase',
  'settings.stagesPanel.color': 'Colore',
  'settings.stagesPanel.loadError': 'Impossibile caricare le fasi',
  'settings.stagesPanel.addSuccess': 'Fase {type} aggiunta con successo',
  'settings.stagesPanel.addError': 'Impossibile aggiungere la fase',
  'settings.stagesPanel.reorderSuccess': 'Ordine delle fasi aggiornato con successo',
  'settings.stagesPanel.reorderError': "Impossibile aggiornare l'ordine delle fasi",
  'settings.stagesPanel.deleteStage': 'Elimina Fase',
  'settings.stagesPanel.deleteError': 'Impossibile Eliminare la Fase',
  'settings.stagesPanel.cannotDelete': 'Impossibile Eliminare la Fase',
  'settings.stagesPanel.selectDestination': 'Seleziona una fase di destinazione per {count} {type} prima di eliminare.',
  'settings.stagesPanel.leads': 'contatti',
  'settings.stagesPanel.tasks': 'attività',
  'settings.stagesPanel.showOnKanban': 'Mostra su Kanban',
  'settings.stagesPanel.visibilitySuccess': 'Fase {status} sulla board Kanban',
  'settings.stagesPanel.enabled': 'attivata',
  'settings.stagesPanel.disabled': 'disattivata',
  'settings.stagesPanel.visibilityError': 'Impossibile aggiornare la visibilità della fase',
  'settings.stagesPanel.noStages': 'Nessuna fase {type} configurata',
  'settings.stagesPanel.containsActiveItems': 'La Fase Contiene Elementi Attivi',
  'settings.stagesPanel.moveTo': 'Sposta {type} in:',
  'settings.stagesPanel.emptyStage': 'Questa fase è vuota e può essere eliminata in sicurezza.',
  'settings.stagesPanel.moveAndDelete': 'Sposta {count} Elementi ed Elimina',

  // Pannello Utenti e Ruoli
  'settings.users.title': 'Gestione Utenti e Ruoli',
  'settings.users.description': 'Gestisci membri del team, permessi e assegnazioni di ruolo',
  'settings.users.loadError': 'Impossibile caricare i dati di utenti e ruoli',
  'settings.users.usersTab': 'Utenti',
  'settings.users.rolesTab': 'Ruoli',
  'settings.users.invitationsTab': 'Inviti in Sospeso',
  'settings.users.teamMembers': 'Membri del Team',
  'settings.users.inviteUser': 'Invita Utente',
  'settings.users.inviteNewUser': 'Invita Nuovo Utente',
  'settings.users.inviteDescription': 'Invia un invito a un nuovo membro del team',
  'settings.users.firstName': 'Nome',
  'settings.users.firstNamePlaceholder': 'Inserisci nome',
  'settings.users.lastName': 'Cognome',
  'settings.users.lastNamePlaceholder': 'Inserisci cognome',
  'settings.users.emailAddress': 'Indirizzo Email',
  'settings.users.emailPlaceholder': 'Inserisci indirizzo email',
  'settings.users.role': 'Ruolo',
  'settings.users.selectRole': 'Seleziona un ruolo',
  'settings.users.sending': 'Invio...',
  'settings.users.sendInvitation': 'Invia Invito',
  'settings.users.userExists': 'Utente già esistente',
  'settings.users.userExistsDesc': 'Un utente con questo indirizzo email esiste già nella tua organizzazione',
  'settings.users.invitationCreated': 'Invito Creato',
  'settings.users.invitationCreatedEmailFailed': "Invito creato ma l'invio email è fallito. Configura il segreto RESEND_API_KEY nel tuo progetto Supabase.",
  'settings.users.invitationSent': 'Invito utente inviato con successo',
  'settings.users.invitationError': "Impossibile inviare l'invito",
  'settings.users.2faToggled': '2FA {status} con successo',
  'settings.users.enabled': 'attivato',
  'settings.users.disabled': 'disattivato',
  'settings.users.2faError': "Impossibile aggiornare l'impostazione 2FA",
  'settings.users.passwordResetSent': 'Email di reset password inviata con successo',
  'settings.users.passwordResetError': "Impossibile inviare l'email di reset password",
  'settings.users.userDisabled': 'Utente disattivato con successo',
  'settings.users.disableError': "Impossibile disattivare l'utente",
  'settings.users.userEnabled': 'Utente attivato con successo',
  'settings.users.enableError': "Impossibile attivare l'utente",
  'settings.users.impersonateSuccess': 'Sessione di impersonificazione avviata in nuova scheda',
  'settings.users.impersonateError': 'Impossibile avviare la sessione di impersonificazione',
  'settings.users.userUpdated': 'Dettagli utente aggiornati con successo',
  'settings.users.userUpdateError': "Impossibile aggiornare i dettagli dell'utente",
  'settings.users.roleSaved': 'Ruolo {action} con successo',
  'settings.users.updated': 'aggiornato',
  'settings.users.created': 'creato',
  'settings.users.roleSaveError': 'Impossibile salvare il ruolo',
  'settings.users.table.name': 'Nome',
  'settings.users.table.email': 'Email',
  'settings.users.table.role': 'Ruolo',
  'settings.users.table.status': 'Stato',
  'settings.users.table.lastLogin': 'Ultimo Accesso',
  'settings.users.table.sent': 'Inviato',
  'settings.users.table.expires': 'Scade',
  'settings.users.table.actions': 'Azioni',
  'settings.users.noRole': 'Nessun Ruolo',
  'settings.users.active': 'Attivo',
  'settings.users.inactive': 'Inattivo',
  'settings.users.never': 'Mai',
  'settings.users.resetPassword': 'Reimposta Password',
  'settings.users.impersonateUser': 'Impersona Utente (presto)',
  'settings.users.editDetails': 'Modifica Dettagli',
  'settings.users.disableUser': 'Disattiva Utente',
  'settings.users.enableUser': 'Attiva Utente',
  'settings.users.rolesPermissions': 'Ruoli e Permessi',
  'settings.users.createRole': 'Crea Ruolo',
  'settings.users.system': 'Sistema',
  'settings.users.noDescription': 'Nessuna descrizione',
  'settings.users.more': 'altri',
  'settings.users.pendingInvitations': 'Inviti in Sospeso',
  'settings.users.noPendingInvitations': 'Nessun invito in sospeso',
  'settings.users.editRole': 'Modifica Ruolo',
  'settings.users.createNewRole': 'Crea Nuovo Ruolo',
  'settings.users.roleDialogDesc': 'Configura i permessi del ruolo per la tua organizzazione',
  'settings.users.roleName': 'Nome Ruolo',
  'settings.users.roleNamePlaceholder': 'Inserisci nome ruolo',
  'settings.users.roleDescription': 'Descrizione',
  'settings.users.roleDescPlaceholder': 'Inserisci descrizione ruolo',
  'settings.users.permissions': 'Permessi',
  'settings.users.updateRole': 'Aggiorna Ruolo',
  'settings.users.invitationExists': 'Invito Già Esistente',
  'settings.users.invitationExistsDesc': 'Un invito per questo indirizzo email esiste già ed è ancora in sospeso.',
  'settings.users.close': 'Chiudi',
  'settings.users.resending': 'Reinvio...',
  'settings.users.resendInvitation': 'Reinvia Invito',
  'settings.users.editUserDetails': 'Modifica Dettagli Utente',
  'settings.users.editUserDesc': "Aggiorna le informazioni dell'utente e l'assegnazione del ruolo",
  'settings.users.emailCannotChange': "L'email non può essere modificata",
  'settings.users.phone': 'Telefono',
  'settings.users.phonePlaceholder': 'Inserisci numero di telefono',
  'settings.users.saveChanges': 'Salva Modifiche',

  // Comuni
  'common.save': 'Salva',
  'common.saving': 'Salvataggio...',
  'common.cancel': 'Annulla',
  'common.error': 'Errore',
  'common.success': 'Successo',

  // Pagina Impostazioni - Chrome
  'settings.page.title': 'Impostazioni',
  'settings.page.subtitle': 'Gestisci la configurazione e le preferenze della tua organizzazione',
  'settings.nav.organisation': 'Organizzazione',
  'settings.nav.organisationDesc': 'Dettagli aziendali e preferenze',
  'settings.nav.usersRoles': 'Utenti e Ruoli',
  'settings.nav.usersRolesDesc': 'Gestisci membri del team e permessi',
  'settings.nav.stages': 'Fasi',
  'settings.nav.stagesDesc': 'Configura flussi di lavoro contatti e modifiche',
  'settings.nav.fittingRooms': 'Camerini di Prova',
  'settings.nav.fittingRoomsDesc': 'Gestisci le sedi degli appuntamenti',
  'settings.nav.businessHours': 'Orari di Apertura',
  'settings.nav.businessHoursDesc': 'Configura orari operativi e festività',
  'settings.nav.integrations': 'Integrazioni',
  'settings.nav.integrationsDesc': 'Collega servizi esterni',
  'settings.nav.templates': 'Modelli',
  'settings.nav.templatesDesc': 'Modelli di messaggi email e SMS',
  'settings.nav.taskTemplates': 'Modelli Attività',
  'settings.nav.taskTemplatesDesc': 'Regole di generazione automatica attività',
  'settings.nav.portalContent': 'Contenuti Portale',
  'settings.nav.portalContentDesc': 'Gestisci FAQ e articoli di aiuto',
  'settings.nav.branding': 'Branding Portale',
  'settings.nav.brandingDesc': 'Personalizza aspetto del portale clienti',
  'settings.nav.portalAuth': 'Autenticazione Portale',
  'settings.nav.portalAuthDesc': 'Configura codici OTP e impostazioni magic link',
  'settings.nav.leadRules': 'Regole Contatti',
  'settings.nav.leadRulesDesc': 'Regole automatiche di follow-up per i contatti',
  'settings.nav.notifications': 'Notifiche',
  'settings.nav.notificationsDesc': 'Impostazioni notifiche push ed email',
  'settings.nav.translations': 'Traduzioni Documenti',
  'settings.nav.translationsDesc': 'Gestisci traduzioni documenti PDF',
  'settings.nav.billing': 'Fatturazione',
  'settings.nav.billingDesc': 'Dettagli abbonamento e pagamento',
  'settings.nav.customFields': 'Campi Personalizzati',
  'settings.nav.customFieldsDesc': 'Crea campi personalizzati per contatti e clienti',
  'settings.nav.badgeBeta': 'Beta',
  'settings.nav.badgePwa': 'PWA',
  'settings.stripe.error': 'Errore',
  'settings.stripe.connectionFailed': 'Connessione Stripe fallita: {error}',
  'settings.stripe.success': 'Successo',
  'settings.stripe.connectedSuccessfully': 'Stripe connesso con successo',
  'settings.stripe.failedToComplete': 'Impossibile completare la connessione Stripe',

  // Procurement / Purchase Orders
  'purchase_orders': 'Ordini di Acquisto',
  'po.title': 'Ordini di Acquisto',
  'po.subtitle': 'Gestisci ordini fornitore, ricezione e allocazioni',
  'po.search': 'Cerca PO # o fornitore...',
  'po.empty': 'Nessun ordine di acquisto trovato',
  'po.notFound': 'Ordine di acquisto non trovato',
  'po.create.button': 'Crea OdA',
  'po.create.title': 'Crea Ordine di Acquisto',
  'po.create.supplier': 'Fornitore',
  'po.create.selectSupplier': 'Seleziona un fornitore',
  'po.create.supplierRequired': 'Seleziona un fornitore',
  'po.create.currency': 'Valuta',
  'po.create.expectedDelivery': 'Consegna Prevista',
  'po.create.notes': 'Note',
  'po.create.submit': 'Crea Bozza OdA',
  'po.create.success': 'Ordine di acquisto creato',
  'po.status.all': 'Tutti',
  'po.status.draft': 'Bozza',
  'po.status.sent': 'Inviato',
  'po.status.confirmed': 'Confermato',
  'po.status.shipped': 'Spedito',
  'po.status.partially_received': 'In Ricezione',
  'po.status.received': 'Ricevuto',
  'po.status.cancelled': 'Annullato',
  'po.statusChanged': 'Stato aggiornato',
  'po.noDeliveryDate': 'Nessuna data di consegna',
  'po.table.number': 'OdA #',
  'po.table.supplier': 'Fornitore',
  'po.table.status': 'Stato',
  'po.table.expectedDelivery': 'Consegna Prevista',
  'po.table.total': 'Totale',
  'po.table.createdAt': 'Creato',
  'po.tabs.items': 'Articoli',
  'po.tabs.allocations': 'Allocazioni',
  'po.tabs.invoice': 'Fattura',
  'po.actions.send': 'Invia',
  'po.actions.confirm': 'Conferma',
  'po.actions.ship': 'Spedisci',
  'po.actions.cancel': 'Annulla',
  'po.items.add': 'Aggiungi Articolo',
  'po.items.addTitle': 'Aggiungi Riga',
  'po.items.product': 'Prodotto',
  'po.items.selectProduct': 'Seleziona un prodotto',
  'po.items.quantity': 'Quantità',
  'po.items.unitCost': 'Costo Unitario',
  'po.items.ordered': 'Ordinato',
  'po.items.received': 'Ricevuto',
  'po.items.lineTotal': 'Totale Riga',
  'po.items.empty': 'Nessun articolo — aggiungi prodotti a questo OdA',
  'po.items.added': 'Articolo aggiunto',
  'po.items.deleted': 'Articolo rimosso',
  'po.receive.button': 'Ricevi',
  'po.receive.title': 'Ricevi Articoli',
  'po.receive.ordered': 'Ordinato',
  'po.receive.received': 'Ricevuto',
  'po.receive.remaining': 'Rimanente',
  'po.receive.qty': 'Ricevi',
  'po.receive.submit': 'Conferma Ricezione',
  'po.receive.noItems': 'Inserisci le quantità da ricevere',
  'po.receive.success': 'Articoli ricevuti con successo',
  'po.allocations.add': 'Alloca',
  'po.allocations.addTitle': 'Alloca Riga Ordine',
  'po.allocations.soLine': 'Riga Ordine di Vendita',
  'po.allocations.selectSOLine': 'Seleziona segnale di domanda...',
  'po.allocations.qty': 'Quantità Allocata',
  'po.allocations.allocate': 'Alloca',
  'po.allocations.created': 'Allocazione creata',
  'po.allocations.none': 'Nessuna allocazione',
  'po.allocations.order': 'Ordine',
  'po.allocations.customer': 'Cliente',
  'po.allocations.allocated': 'Allocato',
  'po.allocations.fulfilled': 'Evaso',
  'po.allocations.risk': 'Rischio',
  'po.invoice.title': 'Fattura Fornitore',
  'po.invoice.ref': 'Riferimento Fattura',
  'po.invoice.amount': 'Importo Fattura',
  'po.invoice.date': 'Data Fattura',
  'po.invoice.fileUrl': 'URL File',
  'po.orderDetail.tab': 'Approvvigionamento',
  'po.orderDetail.title': 'Allocazioni Ordini di Acquisto',
  'po.orderDetail.noAllocations': 'Nessuna allocazione di approvvigionamento per questo ordine',
  'po.supplier.noPOs': 'Nessun ordine di acquisto per questo fornitore',

  // Brands & Collections
  'settings.nav.brandsCollections': 'Brand e Collezioni',
  'settings.nav.brandsCollectionsDesc': 'Gestisci catalogo brand e linee collezione',
  'settings.brands.title': 'Brand e Collezioni',
  'settings.brands.addBrand': 'Aggiungi Brand',
  'settings.brands.addBrandDialogDesc': 'Crea un nuovo brand e poi aggiungi le collezioni dalla lista.',
  'settings.brands.addBrandPlaceholder': 'Inserisci nome brand...',
  'settings.brands.addCollectionPlaceholder': 'Aggiungi collezione...',
  'settings.brands.searchPlaceholder': 'Cerca brand o collezioni...',
  'settings.brands.filters.title': 'Filtri',
  'settings.brands.filters.dialogDesc': 'Affina e ordina la lista dei brand.',
  'settings.brands.filters.source': 'Origine',
  'settings.brands.filters.visibility': 'Visibilita',
  'settings.brands.filters.sort': 'Ordina',
  'settings.brands.filters.pageSize': 'Elementi per pagina',
  'settings.brands.filters.allSources': 'Tutte le origini',
  'settings.brands.filters.sharedOnly': 'Solo condivisi',
  'settings.brands.filters.customOnly': 'Solo personalizzati',
  'settings.brands.filters.visibleOnly': 'Solo visibili',
  'settings.brands.filters.hiddenOnly': 'Solo nascosti',
  'settings.brands.filters.allVisibility': 'Tutta la visibilita',
  'settings.brands.filters.clear': 'Pulisci filtri',
  'settings.brands.filters.apply': 'Applica',
  'settings.brands.sort.nameAsc': 'Nome (A-Z)',
  'settings.brands.sort.nameDesc': 'Nome (Z-A)',
  'settings.brands.sort.collectionsDesc': 'Piu collezioni',
  'settings.brands.sort.collectionsAsc': 'Meno collezioni',
  'settings.brands.table.brand': 'Brand',
  'settings.brands.table.type': 'Tipo',
  'settings.brands.table.collections': 'Collezioni',
  'settings.brands.table.status': 'Stato',
  'settings.brands.table.actions': 'Azioni',
  'settings.brands.status.active': 'Attivo',
  'settings.brands.status.hidden': 'Nascosto',
  'settings.brands.emptyFiltered': 'Nessun brand corrisponde ai filtri correnti.',
  'settings.brands.pagination.showing': 'Visualizzazione {from}-{to} di {total}',
  'settings.brands.pagination.previous': 'Precedente',
  'settings.brands.pagination.next': 'Successivo',
  'settings.brands.shared': 'Condiviso',
  'settings.brands.custom': 'Personalizzato',
  'settings.brands.collectionsCount': 'collezioni',
  'settings.brands.noCollections': 'Nessuna collezione ancora',
  'settings.brands.noBrands': 'Nessun brand ancora. Aggiungi il primo sopra.',
  'settings.brands.hiddenTitle': 'Brand Nascosti',
  'settings.brands.hide': 'Nascondi',
  'settings.brands.unhide': 'Mostra',
  'settings.brands.collapse': 'Chiudi',
  'settings.brands.expand': 'Mostra',
  'settings.brands.brandAdded': 'Brand aggiunto',
  'settings.brands.brandDeleted': 'Brand eliminato',
  'settings.brands.collectionAdded': 'Collezione aggiunta',
  'settings.brands.collectionDeleted': 'Collezione eliminata',
};
